import React from "react";
import "../style/Skills.css";
import { Box, Typography } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";

function Skills() {
  const data = [
    {
      title: "Developement Process",
      description:
        "I leverage Agile frameworks to drive dynamic and iterative development, ensuring flexibility, collaboration, and rapid delivery of high-quality software solutions.",
    },
    {
      title: "Tools",
      description:
        "I proficiently utilize tools such as draw.io, Balsamiq, Git, and GitHub to streamline and enhance the design and version control aspects of the development process.",
    },
    {
      title: "Technologies",
      description:
        "I specialize in developing cutting-edge solutions using both Web 2.0 and Web 3.0 technologies, harnessing the power of the internet to create dynamic and forward-looking digital experiences.",
    },
    {
      title: "Business Strategy",
      description:
        "I excel in solving complex business and strategy problems, ensuring strategic alignment through thoughtful analysis and effective decision-making.",
    },
    {
      title: "Project Management",
      description:
        "I demonstrate proficiency in project management, adeptly handling task planning and milestone tracking to ensure efficient and timely project execution.",
    },
    {
      title: "Personal Skills",
      description:
        "I possess a diverse set of personal skills, including strong decision-making, effective teamwork, analytical prowess, adaptability, research proficiency and a keen ability for competitive analysis.",
    },
  ];

  const [showText, setShowText] = React.useState(
    new Array(data.length).fill(false)
  );

  const toggleDescription = (index) => {
    const newShowText = [...showText];
    newShowText[index] = !newShowText[index];
    setShowText(newShowText);
  };

  return (
    <Box
      id="Skills"
      height={"fit-content"}
      display={"flex"}
      alignItems={"center"}
      justifyContent={"center"}
      my={{ xs: 8, sm: 0, lg: 5 }}
      px={{ xs: 1, sm: 0, lg: 5 }}
    >
      <Box
        flexDirection={{ xs: "column", lg: "row" }}
        sx={{
          display: "flex",
          width: "100%",
          padding: { xs: "10px", sm: "100px" },
          gap: "60px",
        }}
      >
        <div
          style={{
            display: "flex",
          }}
        >
          <Typography
            variant="h1"
            fontFamily={"M PLUS 1, sans-serif"}
            fontSize={{ xs: "2.5rem", sm: "3.8rem", lg: "3.5rem" }}
          >
            My diverse skill set encompasses a variety of expertise, showcasing
            proficiency in distinct areas.
          </Typography>
        </div>
        <Box
          sx={{
            display: "flex",
            width: { xs: "100%", lg: "75%" },
            alignItems: "center",
            justifyContent: "start",
            flexDirection: "column",
            gap: "20px",
          }}
        >
          {data?.map((item, index) => (
            <div key={index}>
              <div role="button" onClick={() => toggleDescription(index)}>
                <div className="col">
                  <Box
                    className="p-3 text-start"
                    sx={{
                      height: !showText[index]
                        ? { xs: "55px", sm: "60px" }
                        : { xs: "140px", sm: "140px", lg: "150px" },
                      transition: "height .5s ease-in-out",
                      overflow: "hidden",
                    }}
                  >
                    <Typography
                      variant="subtitle1"
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        fontSize: { xs: "1.1rem", sm: "1.8rem" },
                        lineHeight: { xs: ".8rem", sm: "1rem" },
                        letterSpacing: ".6px",
                      }}
                    >
                      <span>
                        0{index + 1}. {item.title}
                      </span>
                      {showText[index] ? <RemoveIcon /> : <AddIcon />}
                    </Typography>
                    <Typography
                      variant="subtitle1"
                      sx={{
                        color: "rgba(0, 0, 0,0.7)",
                        opacity: !showText[index] ? 0 : 1,
                        transition: "all .5s ease-in-out",
                        transform: !showText[index] ? "scale(0.9)" : "scale(1)",
                        fontSize: { xs: "14px", sm: "18px" },
                        paddingLeft: { xs: "40px", sm: "30px" },
                        paddingTop: { xs: "10px", sm: "20px", lg: "10px" },
                        lineHeight: "1.2rem",
                        fontWeight: 300,
                        letterSpacing: ".7px",
                        display: "-webkit-box",
                        WebkitLineClamp: {xs: 4, sm: 3, lg: 4},
                        overflow: "hidden",
                        WebkitBoxOrient: "vertical",
                      }}
                    >
                      {item.description}
                    </Typography>
                  </Box>
                </div>
              </div>
            </div>
          ))}
        </Box>
      </Box>
    </Box>
  );
}

export default Skills;
